import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { Region } from 'src/app/shared/models/dtos/region/region';
@Component({
  selector: 'app-region-selector',
  templateUrl: './region-selector.component.html',
  styleUrls: ['./region-selector.component.scss'],
})
/**
 * Region Selector component
 */
export class RegionSelectorComponent {
  userRegionFormControl = new FormControl(
    this.authenticatedUserService.currentRegion
  );

  /**
   * Constructor for RegionSelectorComponent
   */
  constructor(private authenticatedUserService: AuthenticatedUserService) {}

  /**
   * Current region of authenticated admin
   */
  get currentRegion() {
    return this.authenticatedUserService.currentRegion;
  }

  /**
   * Authenticated admin
   */
  get admin() {
    return this.authenticatedUserService.admin;
  }

  /**
   * @param {Region} region region to extract name from
   * @return {string} extracted region name
   */
  regionName(region: Region): string {
    return region.name;
  }

  /**
   * Triggers region change
   */
  changeCurrentRegion(): void {
    const selectedRegion = this.userRegionFormControl.value;

    if (!selectedRegion || !this.admin?.regions) {
      return;
    }

    const matchingRegion = this.admin.regions.find(
      (region) => region.id === selectedRegion.id
    );

    if (matchingRegion) {
      this.authenticatedUserService.currentRegion = matchingRegion;
    }
  }
}
